module.exports = __webpack_public_path__ + "img/top_teikakaku.94ef6fda.gif";